import React, { useContext, useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"
import { useTenantsApp } from "../../Context/TenantsApp/TenantsAppContext";
import { DESELECT_ALL_TENANT_IDS, SET_ERROR, SET_PROJECT, TOGGLE_SYNC_ALL_TENANTS_DIALOG, UPDATE_TENANT_BY_TENANT_ID } from "./TenantsAppEvents";
import { syncMasterProjectToAllTenants } from "../../API/Tenant/Tenant";
import { usePropsStoreValue } from '../../Hooks/PropStore/usePropsStore';
import InnerLoader from "../Shared/Loader/InnerLoader";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import { GlobalContext } from "../../Renderers/GlobalContext";
import { useTranslation } from "react-i18next";

const SyncAllTenantsDialog = () => {

    const { state, dispatch } = useTenantsApp();
    const { user } = useContext(GlobalContext).state
    const project = usePropsStoreValue('project');
    const [inProgress, setInProgress] = useState(false);

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    const handleClose = () => {
        dispatch({ type: TOGGLE_SYNC_ALL_TENANTS_DIALOG });
    }

    const handleSyncAllTenants = async () => {
        setInProgress(true);
        let tenantsToSync = state.tenants.filter(tenant => tenant.syncToProd || tenant.syncToTest);

        // If no tenants are selected for sync, exit early
        if (tenantsToSync.length === 0) return;

        // Map tenants to the required format
        tenantsToSync = tenantsToSync.map(tenant => {
            return {
                tenantId: tenant._id,
                syncToProd: tenant.syncToProd || false, // Ensure syncToProd is always a boolean
                syncToTest: tenant.syncToTest || false // Ensure syncToTest is always a boolean
            }
        });

        const response = await syncMasterProjectToAllTenants(project._id, tenantsToSync, user.azureId);
        dispatch({ type: DESELECT_ALL_TENANT_IDS });
        if (response.status === "success") {
            for (const tenant of response.data) {
                dispatch({
                    type: UPDATE_TENANT_BY_TENANT_ID,
                    payload: {
                        tenantId: tenant.tenantId,
                        data: {
                            syncStatus: tenant.syncStatus
                        }
                    }
                });
            }
        } else {
            if (response.message === "App has schema changes") {
                dispatch({
                    type: SET_PROJECT,
                    payload: response.data
                });
            }
            dispatch({
                type: SET_ERROR,
                payload: response.message
            });
        }
        setInProgress(false);
        handleClose();
    }

    return (
        <Dialog
            width={"25%"}
            title={t("confirm_sync")}
            onClose={handleClose}>
            <>
                <div className="d-flex my-4 align-items-center dialog-content">
                    <i className="fas fa-exclamation-triangle text-danger display-7 me-4"></i>
                    <div>
                        <p>
                            {t("sync_tenants_message")}
                        </p>
                        <div className="mt-1">
                            <p>
                                {t("sync_tenants_message2")}
                            </p>
                        </div>
                    </div>
                </div>
                <DialogActionsBar layout="end">
                    <div className="m-3">
                        {inProgress && <OverlayLoader />}
                        {inProgress && (
                            <small className="mt-2">
                                <div className="d-inline-block">
                                    <InnerLoader borderColor="green" />
                                    <span className="me-4 text-danger"></span>
                                </div>
                            </small>
                        )}
                        <button
                            onClick={handleClose}
                            className="btn btn-secondary">
                            {t("cancel_button")}
                        </button>
                        <button
                            onClick={handleSyncAllTenants}
                            className="btn btn-primary">
                            {t("sync_tenants_button")}
                        </button>
                    </div>
                </DialogActionsBar>
            </>
        </Dialog>
    )
}

export default SyncAllTenantsDialog;